import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { TooltipContent } from '@/components/ui/tooltip';

/** Tooltip glass navy partilhado (status online + peão nos cards da Equipe). */
export function EquipeGlassTooltipContent({
  children,
  className,
  side = 'top',
  sideOffset = 8,
}: {
  children: ReactNode;
  className?: string;
  side?: 'top' | 'bottom' | 'left' | 'right';
  sideOffset?: number;
}) {
  return (
    <TooltipContent
      side={side}
      sideOffset={sideOffset}
      className={cn(
        'z-[80] max-w-[220px] overflow-hidden rounded-xl border-0 p-0 shadow-[0_12px_40px_-12px_rgba(0,0,0,0.65)]',
        'bg-transparent animate-in fade-in-0 zoom-in-95',
        className
      )}
    >
      <div
        className={cn(
          'relative overflow-hidden rounded-xl border px-3.5 py-2.5',
          'border-sky-400/25 bg-gradient-to-br from-[#0a1640]/95 via-[#030023]/95 to-[#071238]/95',
          'backdrop-blur-md'
        )}
      >
        <div
          className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-sky-400/50 to-transparent"
          aria-hidden
        />
        {children}
      </div>
    </TooltipContent>
  );
}
